<template>
  <ul class="mission-honeycomb" :class="{ 'is-completed': mission.hasCompleted }">
    <li
      v-for="(condition, index) in mission.achievementCondition"
      :key="index"
      class="mission-honeycomb__item"
    >
      <mission-hexagon-parts
        :condition="condition"
        :prevCondition="getPrevCondition(index)"
        :mission="mission"
        :checkInMissionsBeingHeld="checkInMissionsBeingHeld"
      />
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import MissionHexagonParts from '@/components/MissionPage/MissionListPane/parts/MissionHexagonParts.vue'
import { MissionProgressCardType } from '@/components/MissionPage/hook/useMissionProgressData'
import MissionProgressDocument from '@/store/stores/collectionModule/documents/mission/MissionProgressDocument'

/**
 * ミッション画面 ミッション達成状況 ハニカム9個パーツ
 */
export default defineComponent({
  name: 'MissionHoneycombNineParts',
  components: {
    MissionHexagonParts,
  },
  props: {
    mission: {
      type: Object as PropType<MissionProgressCardType>,
      required: true,
    },
    /**
     * 開催中のラウンドチェックインまたはイベントチェックインミッション一覧
     */
    checkInMissionsBeingHeld: {
      type: Array as PropType<MissionProgressDocument[]>,
      required: true,
    },
  },
  setup(props) {
    /**
     * 一つ前の達成条件を取得する
     */
    const getPrevCondition = (index: number) =>
      index > 0 ? props.mission.achievementCondition?.[index - 1] : 'noPreviousCondition'

    return {
      getPrevCondition,
    }
  },
})
</script>

<style scoped lang="scss">
.mission-honeycomb {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  width: 277px;

  &__item {
    flex-shrink: 0;

    &:nth-child(4) {
      margin-left: 35px;
    }

    &:nth-child(7) {
      margin-left: 71px;
    }

    &:nth-child(n + 4) {
      margin-top: -18px;
    }
  }

  &.is-completed {
    width: 232px;

    .mission-honeycomb__item {
      &:nth-child(4) {
        margin-left: 28px;
      }

      &:nth-child(7) {
        margin-left: 55px;
      }

      &:nth-child(n + 4) {
        margin-top: -14px;
      }
    }
  }

  @media screen and (min-width: $responsiveTabletWidth) {
    width: 375px;

    &__item {
      &:nth-child(4) {
        margin-left: 48px;
      }

      &:nth-child(7) {
        margin-left: 95px;
      }

      &:nth-child(n + 4) {
        margin-top: -22px;
      }
    }

    &.is-completed {
      width: 289px;
    }
  }
}
</style>
